// Payment presentation. US-17's fourth state (`Completed`) and its per-payment
// settled-item counts belong to Epic 5, which owns the payment view; these are
// the states the current columns can support.

export type PaymentStatus = 'Cancelled' | 'Confirmed' | 'Pending'

export function paymentStatus(payment: {
  cancelledAt?: number | null
  confirmedAt?: number | null
}): PaymentStatus {
  if (payment.cancelledAt != null) return 'Cancelled'
  if (payment.confirmedAt != null) return 'Confirmed'
  return 'Pending'
}

const METHOD_LABELS: Record<string, string> = {
  bank_transfer: 'Bank transfer',
  stripe: 'Card',
}

export function paymentMethodLabel(method: string): string {
  return METHOD_LABELS[method] ?? method
}

function normalizedBankField(value: string): string {
  return value.trim().toLocaleLowerCase().replace(/[\s_-]+/g, '')
}

/**
 * Bank imports preserve the statement's original headings in rawData. Pick
 * out the optional fields that identify a payment, independent of the bank's
 * heading capitalization and spacing.
 */
export function paymentReferenceDetails(
  rawData: Readonly<Record<string, unknown>> | null | undefined,
): string {
  if (!rawData) return ''

  const values = new Map(
    Object.entries(rawData).map(([name, value]) => [
      normalizedBankField(name),
      typeof value === 'string' ? value.trim() : '',
    ]),
  )
  // This is the conventional NZ statement order: particulars, code, reference.
  return ['particulars', 'analysiscode', 'reference']
    .map((name) => values.get(name) ?? '')
    .filter(Boolean)
    .join(' – ')
}
